import React from 'react';
import './RegistrationPromptModal.css'; // Добавьте стили для модального окна
import './AuthForm.css';
import './UserSettings.css';

const RegistrationPromptModal = ({ onClose }) => {
  const handleRegisterClick = () => {
    window.location.href = '/auth'; // Редирект на страницу входа/регистрации
  };

  return (
    <div className="registration-prompt__overlay" onClick={onClose}>
      <div className="registration-prompt__container" onClick={e => e.stopPropagation()}>
        <button className="registration-prompt__close" onClick={onClose}>×</button>
        <h2>Вы не зарегистрированы</h2>
        <p>Хотите зарегистрироваться в системе?</p>
        <div className="registration-prompt__buttons">
          <button onClick={handleRegisterClick} className="authform__button">Зарегистрироваться</button>
          <button onClick={onClose} className="registration-prompt__text-button">Не сейчас</button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPromptModal;
